import ProductGroups from './ProductGroups'
import FilterComponent from './FilterComponent'

import listProductGroups from './gql/listProductGroups'
import getProductGroup from './gql/getProductGroup'
import updateProductGroup from './gql/updateProductGroup'
import createProductGroup from './gql/createProductGroup'

import columns from './sideListColumns'

const sections = t => ([{
	label: t('options_section.sub_sections.statistic_groups'),
	link: 'statistic-groups',
	listQuery: listProductGroups,
	initialQueryVariables: { filter: {} },
	itemQuery: getProductGroup,
	createMutation: createProductGroup,
	addNewRecord: true,
	requiredFields: ['name', 'code', 'groupId'],
	typename: 'ProductGroup',
	columns: columns(t),
	subsections: [{
		link: '',
		component: ProductGroups,
		updateMutation: updateProductGroup,
		fields: ['name', 'code', 'groupId']
	}],
	FilterComponent
}])

export default sections
